<template>
<div>
  <div class="websocket-chat-modal" v-if="!changeBtn">
    <div class="websocket-chat-modal-head">
      <div class="websocket-chat-modal-head-left">
        <div class="avaurl-box" :style="{background:'url('+(menteeDetail.headPortrait || MenteeAvatar)+') no-repeat center',backgroundSize:'cover'}"></div>
        <div>{{menteeDetail.firstName}} {{menteeDetail.lastName}}</div>
      </div>
      <div class="websocket-chat-modal-head-right" @click="changeBtn=true">
        Close
      </div>
    </div>
    <div class="websocket-chat-modal-list" id="scrollBottomDiv">
      <div id="heightDiv">
      <div class="more-message" @click="getWebsocketChatListHandle">{{moreBtnContent?'Click to load for more historical messages':'There is no more historical information left' }}</div>
      <!-- 循环留言 -->
      <div>
        <div v-if="websocketChatList.length>0">
          <div class="chat-list-main" v-for="(item, index) in websocketChatList" :key="index">
              <div class="chat-list-main-left">
                <div v-if="item.role==='MENTEE'">
                  <div class="user-info">
                    <span class="name">{{menteeDetail.firstName}} {{menteeDetail.lastName}}</span><span class="time">{{handleTimeFormat(item.sendTime)}}</span>
                  </div>
                  <div class="content">
                  {{item.msg}}
                  </div>
                </div>
              </div>
              <div class="chat-list-main-right">
                <div v-if="item.role==='MENTOR'">
                  <div class="user-info">
                    <span class="name"></span><span class="time">{{handleTimeFormat(item.sendTime)}}</span>
                  </div>
                  <div class="content self-content">
                  {{item.msg}}
                  </div>
                </div>
              </div>
              <div style="clear: both;"></div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <div class="input-box">
      <Form ref="formValidate">
          <FormItem>
            <Input v-model="content"
                    :border="false"
                    type="textarea"
                    @keyup.enter.native="sendHandle"
                    ></Input>
          </FormItem>
          <div class="websocket-chat-modal-btn">
          <Button type="primary"
                  style="width:96px;"
                  :loading="isSendChat"
                  @click="sendHandle">Send</Button>
          </div>

      </Form>
    </div>
  </div>
  <div class="small-wechat-btn-box" v-else>
      <div>
        <span @click="changeBtn=false">Chat</span>
      </div>
  </div>
</div>
</template>

<script>
import url from '_conf/url'
import { getToken } from '@/libs/util'
import { date2String } from '@/libs/tools'
// api
import { getMenteeDetail } from '@/api/mentee'
import { websocketMsgList } from '@/api/websocket-chat'
// images
import MenteeAvatar from '@/assets/images/home/mentee-avatar.svg'
export default {
  name: 'websocket-chant-modal',
  data () {
    return {
      content: '',
      // 心跳
      heartbeatChat: '',
      heartbeatFrequentlyChat: 5,
      websockSendTimeChat: '',
      websockAcceptTimeChat: '',
      videoPromptChat: '',
      isSendChat: false,
      // 聊天列表
      websocketChatList: [],
      changeBtn: false,
      // 学生信息
      MenteeAvatar,
      menteeDetail: {},
      // 加载更多
      createdTime: Date.now(),
      moreBtnContent: true
    }
  },
  mounted () {
    this.getMenteeDetail()
    this.initWebSocketChat()
    // 获取聊天列表
    this.getWebsocketChatList()
  },
  watch: {
    id () {
      this.getMenteeDetail()
    }
  },
  methods: {
    getMenteeDetail () {
      getMenteeDetail({
        num: this.$route.params.id
      }).then(res => {
        this.menteeDetail = res.data.model
      })
    },
    // 滚动条滚动事件
    scrollBottom () {
      this.$nextTick(() => {
        let scrollDiv = document.getElementById('scrollBottomDiv')
        let heightDiv = document.getElementById('heightDiv')
        scrollDiv.scrollTop = heightDiv.scrollHeight
      })
    },
    // 时间格式换算
    handleTimeFormat (times) {
      return date2String(times, 'MM-DD HH:mm')
    },
    // 获取聊天列表
    getWebsocketChatList () {
      if (!this.moreBtnContent) return false
      let data = {}
      data.appointmentId = this.$route.query.id
      data.lastTime = this.createdTime
      websocketMsgList(data).then(res => {
        if (res.code === 0) {
          if (res.data.model) {
            let messageList = res.data.model
            messageList = messageList.reverse()
            this.createdTime = messageList[0].sendTime
            let nowMessageList = this.websocketChatList
            this.websocketChatList = messageList.concat(nowMessageList)
            this.scrollBottom()
          } else {
            this.moreBtnContent = false
          }
        }
      })
    },
    // 获取聊天列表
    getWebsocketChatListHandle () {
      if (!this.moreBtnContent) return false
      let scrollDiv = document.getElementById('scrollBottomDiv')
      let heightDiv = document.getElementById('heightDiv')
      let beforeHeight = heightDiv.offsetHeight

      let data = {}
      data.appointmentId = this.$route.query.id
      data.lastTime = this.createdTime
      websocketMsgList(data).then(res => {
        if (res.code === 0) {
          if (res.data.model) {
            let messageList = res.data.model
            messageList = messageList.reverse()
            this.createdTime = messageList[0].sendTime
            let nowMessageList = this.websocketChatList
            this.websocketChatList = messageList.concat(nowMessageList)
            this.$nextTick(() => {
              let afterHeight = heightDiv.offsetHeight
              scrollDiv.scrollTop = afterHeight - beforeHeight
            })
          } else {
            this.moreBtnContent = false
          }
        }
      })
    },
    sendHandle () {
      if (!this.content) return false
      this.isSendChat = true
      let actions = { msg: this.content, type: 'TENCENT_MESSAGE' }
      this.websocketsendchat(JSON.stringify(actions))
      this.isSendChat = false
      this.content = ''
    },
    initWebSocketChat () {
      // 初始化weosocket
      let baseUrl = url.replace(/(http)|(https)/, 'ws')
      let id = this.$route.query.id
      let token = getToken()
      const wsuri = `${baseUrl}/websocket/tencent/msg/${id}/${token}`

      this.websocketchat = new WebSocket(wsuri)
      this.websocketchat.onmessage = this.websocketchatonmessage
      this.websocketchat.onopen = this.websocketchatonopen
      this.websocketchat.onerror = this.websocketchatonerror
      this.websocketchat.onclose = this.websocketchatclose
    },
    websocketchatonopen () {
      this.heartbeatStartChat()
    },
    websocketchatonerror () {
      // 连接建立失败重连
      this.initWebSocketChat()
      this.content = ''
      this.isSendChat = false
    },
    websocketchatonmessage (e) {
      let info = JSON.parse(e.data)
      // 数据接收
      if (info && info.type === 'TENCENT_MESSAGE') {
        this.websocketChatList.push(info)
        this.scrollBottom()
      }
      if (e.data) {
        if ((Date.now() - this.websockSendTimeChat) > 4000) {
          this.videoPromptChat = 'Network anomaly, please be patient'
          // this.$zlr_message(this.videoPromptChat, 'error')
          // this.messageEndChat()
        }
        this.websockAcceptTimeChat = Date.now()
      }
    },
    messageEndChat () {
      let message = setTimeout(() => {
        this.videoPromptChat = ''
        clearTimeout(message)
      }, 5000)
    },
    websocketCloseConnectChat () {
      this.websocketchat.close()
    },
    websocketchatclose () {
      this.content = ''
      this.isSendChat = false
    },
    websocketsendchat (Data) {
      // 数据发送
      this.websocketchat.send(Data)
    },
    // 开始心跳
    heartbeatStartChat () {
      this.heartbeatEndChat()
      this.heartbeatChat = setInterval(() => {
        this.websockSendTimeChat = Date.now()
        if (this.websockAcceptTimeChat && (this.websockSendTimeChat - this.websockAcceptTimeChat > 60000)) {
          // this.$zlr_message('Network error, please log out and log in again or refresh the page', 'error')
        }
        let actions = { msg: '', type: 'HEARTBEAT' }
        this.websocketsendchat(JSON.stringify(actions))
      }, this.heartbeatFrequentlyChat * 1000)
    },
    // 结束心跳
    heartbeatEndChat () {
      clearInterval(this.heartbeatChat)
    }
  },
  beforeDestroy () {
    if (this.websocketchat) {
      this.websocketCloseConnectChat()
    }
    if (this.heartbeatChat) {
      this.heartbeatEndChat()
    }
  }
}
</script>

<style lang='less' scoped>
.websocket-chat-modal{
  position:fixed;
  bottom:0px;
  right:0;
  width:330px;
  height:540px;
  z-index: 1999;
  background:#ffffff;
  border-radius: 8px;
  box-shadow:  2px 5px 30px rgba(0, 0, 0 ,.16);
  &-head{
    padding:30px;
    display: flex;
    justify-content: space-between;
    background-color:#6589dd;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    color:#ffffff;
    &-left{
      display:flex;
      flex-direction: row;
       align-items: center;
    }
    &-right{
      cursor: pointer;
    }
  }
  &-list{
    padding:0 14px 14px;
    height:312px;
    overflow-y:auto;
    .more-message{
      text-align: center;
      padding:14px 0;
      font-size: 12px;
      color: rgb(119, 119, 119);
      cursor: pointer;
    }
    .chat-list-main{
      &-left,&-right{
        padding:10px 10px 10px 0;
      }
      &-left{
        float: left;
        text-align: left;
        max-width: calc(100% - 50px);
      }
      &-right{
        float: right;
        text-align: right;
        max-width: calc(100% - 50px);
      }
      .user-info{
        color: rgb(178, 178, 178);
        font-size: 12px;
        margin-bottom: 2px;
        .name{
          padding-right:10px;
        }
      }
      .content{
        border-radius: 5px;
        border: 1px solid rgb(240, 240, 240);
        padding: 10px 15px;
        border-radius: 3px;
        font-size: 13px;
        word-break: break-word;
        background-color: #F6F6F6;
      }
      .self-content{
       background-color:#E3EAF9;
      }
    }
  }
  &-btn{
    text-align: right;
  }
  .input-box{
    padding:14px;
  }
}
.small-wechat-btn-box{
  position:fixed;
  bottom:14%;
  right:30px;
  span{
    display:inline-block;
    width:50px;
    height:50px;
    border-radius: 50%;
    background:#6589dd;
    color:#ffffff;
    font-size:14px;
    text-align:center;
    line-height: 50px;
    cursor: pointer;
  }
}
.avaurl-box{
  width:24px;
  height:24px;
  margin-right:10px;
  border-radius: 50%;
  background-size:cover!important;
  img{
    width:100%;
  }
}
</style>
<style lang='less'>
 .input-box{
    .textarea.ivu-input{
      border:none!important;
    }
  }
</style>
